<script>
  import {getHomepage} from "../api/homepage";
  import { UPLOADS_DIRECTORY } from "../constants";
  
  import {onMount} from "svelte";
  import {marked} from "marked";

  let data = null;

  onMount(async() => {
    try {
      data = await getHomepage("publication");

      data.text = data.text.replaceAll('\n', '<br>')
    } catch(error) {
      console.error(error);
    }
  });
</script>

{#if data}
    <div id="anchor-publication" class="container-fluid block mt-5">
        <div class="row box">
            <div class="col-10 offset-1 col-lg-8 col-xxl-6 offset-lg-2 offset-xxl-3">
                <h1 class="title">{data.header}</h1>
                <p
                        data-aos="fade-right"
                        data-aos-offset="300"
                        class="description col-12 my-4"
                >
                    {@html marked(data.text)}
                </p>
            </div>
        </div>

        <div
                data-aos="fade-left"
                data-aos-offset="500"
                class="d-none d-lg-block col-4 mt-5 visualization"
                style="--publication-background: url('{UPLOADS_DIRECTORY}{data.image.data.attributes.url}')"
        ></div>
    </div>
{/if}

<style>
    #anchor-publication {
        overflow-x: hidden;
    }

    .visualization {
        background-image: var(--publication-background);
        background-size: contain;
        background-position: right;
        background-repeat: no-repeat;
        height: 90vh;
        transform: translateY(-3%);
    }

    .box {
        margin: 0 !important;
    }

    .block {
        display: flex;
        align-items: center;
        min-height: 100vh;
        padding: 0 !important;
        overflow-y: visible;
    }

    .title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
    }

    .description {
        font-family: "Work Sans";
        font-size: 14px;
        line-height: 16px;

        color: #425466;
    }
</style>
